import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ModalBase } from '@components/Modal';
import { Typography } from '@components/Typography';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const Text = styled(Typography, {
    shouldForwardProp: prop => prop !== 'hasDiff',
})(({ hasDiff }) => ({
    color: hasDiff ? 'var(--error-main)' : 'var(--text-primary)',
}));

export const CellWithRadioGroup = styled('div')({
    padding: '10px 0',
    textAlign: 'left',
    minWidth: 192,
});

export const RadioSubtitle = styled(Typography)({
    display: 'block',
    marginTop: '4px',
    color: 'var(--text-secondary)',
});

export const StyledRadio = styled(Radio)({
    color: 'var(--text-secondary)',
    width: '24px',
    height: '24px',
    '&.Mui-checked': {
        color: 'var(--primary-main)',
    },
});

export const StyledFormControlLabel = styled(FormControlLabel)({
    marginRight: 0,
    gap: 16,
});

export const Image = styled('img')({
    width: 'auto',
    height: 74,
    borderRadius: 8,
    objectFit: 'contain',
});
